import type { Mode } from "../../../components/general/types/Modify";
import { api } from "../../../services/jobpermissions.service";
import { useJobPermission } from "./useJobPermission";

const permission = "EditForAnyUser";

export const useCanEditJobDetails = (mode: Mode, fetch: boolean) =>
  useJobPermission(mode, fetch, api.editJobDetails, permission);
